"use strict";
/* eslint-disable */
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
var _default = exports.default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M18.76 18.76h-2.845v-4.456c0-1.062-.019-2.43-1.48-2.43-1.482 0-1.708 1.158-1.708 2.353v4.532H9.882V9.598h2.731v1.252h.038a2.993 2.993 0 0 1 2.695-1.48c2.883 0 3.415 1.896 3.415 4.364l-.001 5.026ZM6.672 8.345a1.651 1.651 0 1 1 0-3.302 1.651 1.651 0 0 1 0 3.302ZM8.094 18.76H5.246V9.598h2.848v9.162ZM20.178 2.4H3.817A1.401 1.401 0 0 0 2.4 3.785v16.43A1.402 1.402 0 0 0 3.817 21.6h16.361a1.405 1.405 0 0 0 1.423-1.386V3.785A1.404 1.404 0 0 0 20.178 2.4"
})), "0 0 24 24", "Linkedin");